import React from "react";
import Mid from "../../src/assets/Mid-line.png";
import "../../src/style/line.css";

const Line = () => {
  return (
    <div className="line">
      {/* Fixed className */}
      <img src={Mid} alt="image" className="top-first" />
    </div>
  );
};

export default Line;
